import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 13px 16px;\n  font-size: 14px;\n  color: ", ";\n\n  &::selection {\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { NOTE } from '../../utils/testing/TestIDs';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.colors.ivory;
});

var Note = function Note(_ref) {
  var text = _ref.text,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-testid": NOTE
  }, text);
};

export { Note };